import React from 'react';
import { Search } from 'lucide-react';
import { Card } from '../../atoms/Card';
import { Input } from '../../atoms/Input';
import { Button } from '../../atoms/Button';

export interface CommentSearchBarProps {
  searchQuery: string;
  onSearchQueryChange: (query: string) => void;
  onSearch: (e: React.FormEvent) => void;
}

export const CommentSearchBar = ({
  searchQuery,
  onSearchQueryChange,
  onSearch,
}: CommentSearchBarProps) => {
  return (
    <Card className="mb-6">
      <form onSubmit={onSearch} className="flex flex-col sm:flex-row gap-4 items-stretch sm:items-center">
        <div className="flex-1 relative min-w-0">
          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5 z-10" />
          <Input
            type="text"
            placeholder="Yorum içeriği, kullanıcı adı veya ID ile ara..."
            value={searchQuery}
            onChange={(e) => onSearchQueryChange(e.target.value)}
            className="pl-10 w-full"
          />
        </div>
        <Button type="submit" variant="primary" className="flex-shrink-0 w-full sm:w-auto">
          Ara
        </Button>
      </form>
    </Card>
  );
};
